<div class="auth-page">
  <a href="#" class="auth-page__home-link" aria-label="Go to home page">
    <i class="fas fa-home"></i>
  </a>

  <div class="auth-card">
    <div class="auth-card__inner">
      <h4 class="auth-card__heading">Forgot Password</h4>
      <p class="auth-card__subheading">ลืมรหัสผ่าน</p>
      <div class="auth-card__divider"></div>

      <div class="auth-form">
        @if (!status) {
          <div class="auth-form__error" style="margin-bottom: 14px;" role="alert">
            <i class="fas fa-exclamation-circle" style="margin-right:6px;"></i>
            Please check your email and phone number
          </div>
        }

        <div class="auth-form__group">
          <label class="auth-form__label" for="forgotEmail">
            Email
            <span class="auth-form__label-thai">อีเมล</span>
          </label>
          <input id="forgotEmail" required email type="email" class="auth-form__input" placeholder="email@address.com"
            [(ngModel)]="email" autocomplete="email" />
        </div>

        <div class="auth-form__group">
          <label class="auth-form__label" for="forgotPhone">
            Phone Number
            <span class="auth-form__label-thai">เบอร์โทร</span>
          </label>
          <input id="forgotPhone" required type="tel" class="auth-form__input" placeholder="0xxxxxxxx" [(ngModel)]="phone"
            autocomplete="tel" />
        </div>

        @if (user) {
          <div class="auth-form__group">
            <label class="auth-form__label" for="forgotNewPass">
              New Password
              <span class="auth-form__label-thai">รหัสผ่านใหม่</span>
            </label>
            <input id="forgotNewPass" type="password" class="auth-form__input" [(ngModel)]="user.password"
              autocomplete="new-password" />
          </div>
        }

        @if (!user) {
          <button (click)="onSubmit()" class="auth-form__submit">
            Confirm
            <span class="auth-form__label-thai">ยืนยัน</span>
          </button>
        }
        @if (user) {
          <button (click)="onSubmitPassword()" class="auth-form__submit">
            Set New Password
            <span class="auth-form__label-thai">ยืนยัน</span>
          </button>
        }
      </div>

      <div class="auth-card__footer">
        <p>ยังไม่เป็นสมาชิก? <a href="/signUp">ลงทะเบียน</a></p>
        <p>Don't have an account? <a href="/signUp">Register</a></p>
      </div>
    </div>
  </div>

  <div class="auth-circles" aria-hidden="true">
    <div class="auth-circle auth-circle--1"></div>
    <div class="auth-circle auth-circle--2"></div>
    <div class="auth-circle auth-circle--3"></div>
    <div class="auth-circle auth-circle--4"></div>
  </div>
</div>

<notifier-container></notifier-container>
